/* eslint-disable */
import {
	Chip,
	Grid,
	IconButton,
	Paper,
	Table,
	tableCellClasses,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow
} from "@mui/material";
import { Suspense, useCallback, useContext, useEffect, useState } from "react";
import { AuthContext, ThemeContext } from "../../../../contexts";
import { BV2Beneficiery } from "../../../../types/BV2Beneficiery.types";
import { Member } from "../../../../types/employee.types";
import initCapitalize from "../../../../utils/commonFunctions/initCapitalize";

import CreateIcon from "@mui/icons-material/Create";
import DeleteIcon from "@mui/icons-material/Delete";
import FaceIcon from "@mui/icons-material/Face";
import TourIcon from "@mui/icons-material/Tour";
import AddIcon from "@mui/icons-material/Add";

import { HiOutlinePencilSquare } from "react-icons/hi2";

import "./VEBBeneficiary.css";
import { styled } from "@mui/material/styles";
import { dateTimeZoneConverter } from "../../../../utils/commonFunctions/date";
import VEBBeneficiaryDialog from "./VEBBeneficiaryDialog/VEBBeneficiaryDialog";
import { DialogProps } from "../../../../types/dialogProps.types";
import { VEBDialogProps } from "../../../../types/VEBBeneficiaryDialogProps";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
	[`&.${tableCellClasses.head}`]: {
		backgroundColor: theme.palette.action.hover
	}
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
	"&:nth-of-type(even)": {
		backgroundColor: theme.palette.action.hover
	},
	// hide last border
	"&:last-child td, &:last-child th": {
		border: 0
	}
}));

const VEBBeneficiary = ({
	primaryBeneficiary,
	setPrimaryBeneficiary,
	contingentBeneficiary,
	setContingentBeneficiary,
	member,
	employee,
	isChild,
	dependents,
	isAutoFilled
}: {
	primaryBeneficiary: BV2Beneficiery[];
	setPrimaryBeneficiary: React.Dispatch<React.SetStateAction<BV2Beneficiery[]>>;
	contingentBeneficiary: BV2Beneficiery[];
	setContingentBeneficiary: React.Dispatch<React.SetStateAction<BV2Beneficiery[]>>;
	member: Member;
	isChild?: boolean;
	employee: Member;
	dependents: Member[];
	isAutoFilled?: boolean;
}) => {
	const authContext = useContext(AuthContext);
	const { theme } = useContext(ThemeContext);
	const [spouse, setSpouse] = useState<Member>();
	const [benenficiaryDependents, setBeneficiaryDependents] = useState<Member[]>([]);
	// BV2 Start
	const [addVEBBeneficiaryDialog, setAddVEBBeneficiaryDialog] = useState<VEBDialogProps>({
		openDialog: false,
		title: "Add Beneficiary",
		actions: [
			{
				label: "Save",
				name: "save",
				callback: () => null
			}
		]
	});

	const [editVEBBeneficiaryDialog, setEditVEBBeneficiaryDialog] = useState<VEBDialogProps>({
		openDialog: false,
		title: "Edit Beneficiary",
		beneficiary: null,
		index: null,
		actions: [
			{
				label: "Save",
				name: "save",
				callback: () => null
			}
		]
	});

	const getTotalPercentage = (beneficiaries: BV2Beneficiery[]) => {
		return beneficiaries.reduce((sum, ben) => sum + Number(ben.percentage || 0), 0);
	};

	const handleOpenEditVEBBeneficiaryDialogClick = useCallback(
		(beneficiary: any, index: any) => {
			setEditVEBBeneficiaryDialog(
				Object.assign({}, editVEBBeneficiaryDialog, {
					openDialog: true,
					beneficiary: beneficiary,
					index: index
				})
			);
		},
		[editVEBBeneficiaryDialog]
	);

	const handleCloseEditVEBBeneficiaryDialogClick = useCallback(() => {
		setEditVEBBeneficiaryDialog(Object.assign({}, editVEBBeneficiaryDialog, { openDialog: false }));
	}, [editVEBBeneficiaryDialog]);

	const handleOpenAddVEBBeneficiaryDialogClick = useCallback(() => {
		const hasFullBeneficiary = [...primaryBeneficiary, ...contingentBeneficiary].some(
			(b) => Number(b.percentage) === 100
		);

		console.log("hasFullBeneficiary=====>", hasFullBeneficiary);

		if (hasFullBeneficiary) {
			alert("A beneficiary already has 100% allocation. You cannot add another.");
			return;
		}
		setAddVEBBeneficiaryDialog(Object.assign({}, addVEBBeneficiaryDialog, { openDialog: true }));
	}, [addVEBBeneficiaryDialog, primaryBeneficiary, contingentBeneficiary]);

	const handleCloseAddVEBBeneficiaryDialogClick = useCallback(() => {
		setAddVEBBeneficiaryDialog(Object.assign({}, addVEBBeneficiaryDialog, { openDialog: false }));
	}, [addVEBBeneficiaryDialog]);

	// BV2 End

	const handleSetToSpouseClick = useCallback(() => {
		let spouseMember: Member | null = null;
		if (member.relationship === "SPOUSE") {
			spouseMember = employee;
		} else {
			if (spouse) {
				spouseMember = spouse;
			}
		}
		if (spouseMember === null) {
			return;
		}

		const existingBeneficiary = primaryBeneficiary.find(
			(ben) =>
				(ben.relationship === "SPOUSE" || ben.relationship === null || ben.relationship.includes("CHILD")) &&
				Number(ben.percentage) === 100
		);

		if (existingBeneficiary) {
			const relationLabel =
				existingBeneficiary.relationship === "SPOUSE"
					? "Spouse"
					: existingBeneficiary.relationship?.includes("CHILD")
					? "Child"
					: "Employee";

			alert(`${relationLabel} is already added with 100% as Primary Beneficiary!`);
			return;
		}
		const newPrimaryBeneficiary: BV2Beneficiery = {
			first_name: spouseMember.first_name,
			last_name: spouseMember.last_name,
			middle_name: spouseMember.middle_name ? spouseMember.middle_name : "",
			type: "PRIMARY",
			insured_SSN: member.SSN,
			relationship: spouseMember.relationship,
			address_line_1: spouseMember.address_line_1,
			address_line_2: spouseMember.address_line_2,
			state: spouseMember.state,
			ZIP: spouseMember.ZIP,
			SSN: spouseMember.SSN,
			date_of_birth: dateTimeZoneConverter(spouseMember.date_of_birth as string) as unknown as string,
			gender: spouseMember.gender,
			percentage: 100,
			phone_number: spouseMember.phone_number
		};
		setPrimaryBeneficiary((prev) => [...prev, newPrimaryBeneficiary]);
	}, [employee, member.SSN, member.relationship, setPrimaryBeneficiary, spouse, primaryBeneficiary]);

	const handleSetToEstateClick = useCallback(() => {
		const newPrimaryBeneficiary: BV2Beneficiery = {
			first_name: member.first_name,
			last_name: member.last_name,
			type: "PRIMARY",
			insured_SSN: member.SSN,
			relationship: "ESTATE",
			address_line_1: member.address_line_1,
			address_line_2: member.address_line_2,
			state: member.state,
			ZIP: member.ZIP,
			SSN: member.SSN,
			date_of_birth: dateTimeZoneConverter(member.date_of_birth as string) as unknown as string,
			gender: member.gender,
			percentage: 100,
			phone_number: member.phone_number,
			middle_name: ""
		};
		setPrimaryBeneficiary((prev) => [...prev, newPrimaryBeneficiary]);
	}, [member, setPrimaryBeneficiary]);

	const getHasBeneficiaryAdded = useCallback(
		(selectedDependent: Member): boolean => {
			let hasAddedBeneficiary = false;
			const beneficiary = [...primaryBeneficiary, ...contingentBeneficiary];
			//let beneficiary = type === "PRIMARY" ? primaryBeneficiary : contingentBeneficiary;
			for (let idx = 0; idx < beneficiary.length; idx++) {
				if (beneficiary[idx].SSN === selectedDependent.SSN) {
					hasAddedBeneficiary = true;
					//alert("Same beneficiary already added!");
					break;
				}
			}
			return hasAddedBeneficiary;
		},
		[contingentBeneficiary, primaryBeneficiary]
	);

	const handleAddPrimaryBeneficiary = useCallback(
		(selectedDependent: Member, type: "PRIMARY" | "CONTINGENT", percentage: number) => {
			const total = getTotalPercentage(primaryBeneficiary);

			if (total + percentage > 100) {
				alert(`Total primary beneficiary percentage cannot exceed 100%. Current: ${total}%`);
				return;
			}

			const newBeneficiary: BV2Beneficiery = {
				first_name: selectedDependent.first_name,
				last_name: selectedDependent.last_name,
				middle_name: selectedDependent.middle_name ? selectedDependent.middle_name : "",
				type: type,
				insured_SSN: member.SSN,
				relationship: selectedDependent.relationship,
				address_line_1: selectedDependent.address_line_1,
				address_line_2: selectedDependent.address_line_2,
				state: selectedDependent.state,
				ZIP: selectedDependent.ZIP,
				SSN: selectedDependent.SSN,
				date_of_birth: dateTimeZoneConverter(selectedDependent.date_of_birth as string) as unknown as string,
				gender: selectedDependent.gender,
				percentage: percentage,
				phone_number: selectedDependent.phone_number
			};
			let hasAddedBeneficiary = false;
			if (selectedDependent.SSN !== "") hasAddedBeneficiary = getHasBeneficiaryAdded(selectedDependent);

			if (hasAddedBeneficiary === false) {
				setPrimaryBeneficiary((prevPrimaryBeneficiary: BV2Beneficiery[]) => {
					return Object.assign([], [...prevPrimaryBeneficiary, newBeneficiary]);
				});
			} else {
				alert("Same beneficiary already added!");
			}
		},
		[getHasBeneficiaryAdded, member.SSN, setPrimaryBeneficiary]
	);
	const handleAddContingentBeneficiary = useCallback(
		(selectedDependent: Member, type: "PRIMARY" | "CONTINGENT", percentage: number) => {
			const newBeneficiary: BV2Beneficiery = {
				first_name: selectedDependent.first_name,
				last_name: selectedDependent.last_name,
				middle_name: selectedDependent.middle_name ? selectedDependent.middle_name : "",
				type: type,
				insured_SSN: member.SSN,
				relationship: selectedDependent.relationship,
				address_line_1: selectedDependent.address_line_1,
				address_line_2: selectedDependent.address_line_2,
				state: selectedDependent.state,
				ZIP: selectedDependent.ZIP,
				SSN: selectedDependent.SSN,
				date_of_birth: dateTimeZoneConverter(selectedDependent.date_of_birth as string) as unknown as string,
				gender: selectedDependent.gender,
				percentage: percentage,
				phone_number: selectedDependent.phone_number
			};
			let hasAddedBeneficiary = false;
			if (selectedDependent.SSN !== "") hasAddedBeneficiary = getHasBeneficiaryAdded(selectedDependent);

			if (hasAddedBeneficiary === false) {
				setContingentBeneficiary((prevContingentBeneficiary: BV2Beneficiery[]) => {
					return Object.assign([], [...prevContingentBeneficiary, newBeneficiary]);
				});
			} else {
				alert("Same beneficiary already added!");
			}
		},
		[getHasBeneficiaryAdded, member.SSN, setContingentBeneficiary]
	);

	const handleDeleteBeneficiery = useCallback(
		(index: number, type: "PRIMARY" | "CONTINGENT") => {
			let beneficiary: BV2Beneficiery[] = [];
			if (type === "PRIMARY") {
				beneficiary = Object.assign([], primaryBeneficiary);
			} else {
				beneficiary = Object.assign([], contingentBeneficiary);
			}
			const filteredBeneficiary = beneficiary.filter((eachBeneficiary, idx) => idx !== index);
			if (type === "PRIMARY") {
				setPrimaryBeneficiary(Object.assign([], filteredBeneficiary));
			} else {
				setContingentBeneficiary(Object.assign([], filteredBeneficiary));
			}
		},
		[contingentBeneficiary, primaryBeneficiary, setContingentBeneficiary, setPrimaryBeneficiary]
	);

	const handleEditBeneficieryClick = useCallback(
		(oldBeneficiary: any, beneficiary: any, index: number, type: "PRIMARY" | "CONTINGENT", percentage: number) => {
			// console.log(beneficiary, index);
			let beneficiaryV2: BV2Beneficiery[] = [];
			const oldType = oldBeneficiary.type;

			// console.log(oldBeneficiary, "oldType", beneficiary);
			if (oldType == beneficiary.type) {
				if (oldType === "PRIMARY") {
					beneficiaryV2 = Object.assign([], primaryBeneficiary);

					beneficiaryV2 = beneficiaryV2.filter((benefit: any) => benefit.SSN != oldBeneficiary.SSN);
					beneficiaryV2.push({ ...beneficiary, percentage: percentage });
					setPrimaryBeneficiary(Object.assign([], beneficiaryV2));
				} else {
					beneficiaryV2 = Object.assign([], contingentBeneficiary);
					beneficiaryV2 = beneficiaryV2.filter((benefit: any) => benefit.SSN != oldBeneficiary.SSN);
					beneficiaryV2.push({ ...beneficiary, percentage: percentage });
					setContingentBeneficiary(Object.assign([], beneficiaryV2));
				}
			} else {
				if (oldType === "PRIMARY") {
					beneficiaryV2 = Object.assign([], primaryBeneficiary);
					beneficiaryV2 = beneficiaryV2.filter((benefit: any) => benefit.SSN != oldBeneficiary.SSN);
					// console.log("oldType", beneficiaryV2, primaryBeneficiary);

					setPrimaryBeneficiary(Object.assign([], beneficiaryV2));
					beneficiaryV2 = Object.assign([], contingentBeneficiary);
					beneficiaryV2.push({ ...beneficiary, percentage: percentage });

					setContingentBeneficiary(Object.assign([], beneficiaryV2));
				} else {
					beneficiaryV2 = Object.assign([], contingentBeneficiary);
					beneficiaryV2 = beneficiaryV2.filter((benefit: any) => benefit.SSN != oldBeneficiary.SSN);
					setContingentBeneficiary(Object.assign([], beneficiaryV2));
					beneficiaryV2 = Object.assign([], primaryBeneficiary);
					beneficiaryV2.push({ ...beneficiary, percentage: percentage });

					setPrimaryBeneficiary(Object.assign([], beneficiaryV2));
				}
			}
		},
		[contingentBeneficiary, primaryBeneficiary, setContingentBeneficiary, setPrimaryBeneficiary]
	);

	const handleEditBeneficiery = useCallback(
		(beneficiary: any, index: number, type: "PRIMARY" | "CONTINGENT") => {
			// console.log("beneficiary", beneficiary);
			beneficiary["type"] = type;
			beneficiary["insured_SSN"] = member.employee_SSN;
			handleOpenEditVEBBeneficiaryDialogClick(beneficiary, index);
			// let beneficiary: BV2Beneficiery[] = [];
			// if (type === "PRIMARY") {
			// 	beneficiary = Object.assign([], primaryBeneficiary);
			// } else {
			// 	beneficiary = Object.assign([], contingentBeneficiary);
			// }
			// const filteredBeneficiary = beneficiary.filter((eachBeneficiary, idx) => idx !== index);
			// if (type === "PRIMARY") {
			// 	setPrimaryBeneficiary(Object.assign([], filteredBeneficiary));
			// } else {
			// 	setContingentBeneficiary(Object.assign([], filteredBeneficiary));
			// }
		},
		[handleOpenEditVEBBeneficiaryDialogClick, member]
	);

	const getSpouse = useCallback(() => {
		const spouse = dependents.find((dependent: Member) => dependent.relationship === "SPOUSE");
		if (spouse) {
			setSpouse(Object.assign({}, spouse));
		}
	}, [dependents]);

	const getBeneficiaryDependents = useCallback(() => {
		if (authContext.member === null) {
			return;
		}
		if (isChild) {
			// console.log("isChild", isChild);
			const _benenficiaryDependents: Member[] = [...dependents, authContext.member].filter(
				(dependent: Member) => dependent.relationship !== "CHILD" && dependent.relationship !== "STEP CHILD"
			);
			setBeneficiaryDependents(Object.assign([], _benenficiaryDependents));
		} else {
			const _benenficiaryDependents: Member[] = [...dependents, authContext.member].filter(
				(dependent: Member) => dependent.relationship !== member.relationship
			);
			setBeneficiaryDependents(Object.assign([], _benenficiaryDependents));
		}
	}, [authContext.member, dependents, isChild, member.relationship]);

	useEffect(() => {
		getBeneficiaryDependents();
		getSpouse();
	}, [getBeneficiaryDependents, getSpouse]);

	return (
		<div className="VEB-beneficiary">
			<Suspense fallback={<div />}>
				<VEBBeneficiaryDialog
					dialogProps={addVEBBeneficiaryDialog}
					dependents={benenficiaryDependents}
					actionType="ADD"
					handleAddPrimaryBeneficiary={handleAddPrimaryBeneficiary}
					handleAddContingentBeneficiary={handleAddContingentBeneficiary}
					handleClose={handleCloseAddVEBBeneficiaryDialogClick}
				/>
			</Suspense>
			<Suspense fallback={<div />}>
				<VEBBeneficiaryDialog
					dialogProps={editVEBBeneficiaryDialog}
					dependents={benenficiaryDependents}
					actionType="EDIT"
					handleAddPrimaryBeneficiary={handleAddPrimaryBeneficiary}
					handleAddContingentBeneficiary={handleAddContingentBeneficiary}
					handleClose={handleCloseEditVEBBeneficiaryDialogClick}
					handleEditBeneficieryClick={handleEditBeneficieryClick}
				/>
			</Suspense>
			<Grid container>
				<Grid item xl={7} lg={7} md={7}>
					<div
						className="theme-plan-sub-header"
						style={{ borderLeftColor: theme.primary_color, fontSize: "0.9rem" }}
					>
						<b>
							{isChild ? "Child" : member?.first_name + " " + member?.last_name} has{" "}
							{primaryBeneficiary.length} PRIMARY and {contingentBeneficiary.length} CONTINGENT
						</b>
					</div>
				</Grid>
				<Grid item xl={5} lg={5} md={5}>
					<Grid container spacing={1} alignItems="flex-end" justifyContent="flex-end">
						{spouse ? (
							<Grid item>
								<Chip
									icon={<FaceIcon />}
									label="Set to Spouse"
									onClick={!isAutoFilled ? handleSetToSpouseClick : undefined}
									disabled={isAutoFilled}
									title={isAutoFilled ? "Auto-filled from dependents" : ""}
								/>
							</Grid>
						) : null}
						<Grid item>
							<Chip icon={<AddIcon />} label="Add" onClick={handleOpenAddVEBBeneficiaryDialogClick} />
						</Grid>
					</Grid>
				</Grid>

				<TableContainer className="theme-plan-inner-section-margin">
					<Table sx={{ minWidth: 400 }} aria-label="simple table">
						<TableHead>
							<TableRow>
								<StyledTableCell className="tcell">
									<b>Name</b>
								</StyledTableCell>
								<StyledTableCell align="right" className="tcell">
									<b>Relation</b>
								</StyledTableCell>
								<StyledTableCell align="right" className="tcell">
									<b>Percentage</b>
								</StyledTableCell>
								<StyledTableCell align="right" className="tcell">
									<b>Type</b>
								</StyledTableCell>
								<StyledTableCell align="right" className="tcell">
									<b>Action</b>
								</StyledTableCell>
							</TableRow>
						</TableHead>

						<TableBody>
							{primaryBeneficiary.map((eachPrimaryBeneficiary, index) => {
								const { first_name, last_name, relationship, percentage } = eachPrimaryBeneficiary;
								return (
									<TableRow key={index}>
										<StyledTableCell component="th" scope="row">
											{first_name + " " + last_name}
										</StyledTableCell>
										<StyledTableCell align="right" component="th" scope="row">
											{relationship === null ? "Employee" : initCapitalize(relationship)}
										</StyledTableCell>
										<StyledTableCell align="right" component="th" scope="row">
											{percentage}
										</StyledTableCell>
										<StyledTableCell align="right" component="th" scope="row">
											PRIMARY
										</StyledTableCell>
										<StyledTableCell align="right" component="th" scope="row">
											<Grid
												container
												spacing={1}
												alignItems="flex-end"
												justifyContent={"flex-end"}
											>
												<Grid item>
													{/* <IconButton>
														<CreateIcon />
													</IconButton> */}
													<IconButton>
														<DeleteIcon
															onClick={() => handleDeleteBeneficiery(index, "PRIMARY")}
														/>
													</IconButton>
													<IconButton>
														<HiOutlinePencilSquare
															onClick={() =>
																handleEditBeneficiery(
																	eachPrimaryBeneficiary,
																	index,
																	"PRIMARY"
																)
															}
														/>
													</IconButton>
												</Grid>
											</Grid>
										</StyledTableCell>
									</TableRow>
								);
							})}
							{contingentBeneficiary.map((eachPrimaryBeneficiary, index) => {
								const { first_name, last_name, relationship, percentage } = eachPrimaryBeneficiary;
								return (
									<TableRow key={index}>
										<StyledTableCell component="th" scope="row">
											{first_name + " " + last_name}
										</StyledTableCell>
										<StyledTableCell align="right" component="th" scope="row">
											{relationship === null ? "Employee" : initCapitalize(relationship)}
										</StyledTableCell>
										<StyledTableCell align="right" component="th" scope="row">
											{percentage}
										</StyledTableCell>
										<StyledTableCell align="right" component="th" scope="row">
											CONTINGENT
										</StyledTableCell>
										<StyledTableCell align="right" component="th" scope="row">
											<Grid
												container
												spacing={1}
												alignItems="flex-end"
												justifyContent={"flex-end"}
											>
												<Grid item>
													<IconButton>
														<DeleteIcon
															onClick={() => handleDeleteBeneficiery(index, "CONTINGENT")}
														/>
													</IconButton>
													<IconButton>
														<span
															style={{ cursor: "pointer", fontSize: "18px" }}
															onClick={() =>
																handleEditBeneficiery(
																	eachPrimaryBeneficiary,
																	index,
																	"CONTINGENT"
																)
															}
														>
															✏️
														</span>
													</IconButton>
												</Grid>
											</Grid>
										</StyledTableCell>
									</TableRow>
								);
							})}
						</TableBody>
					</Table>
				</TableContainer>
			</Grid>
		</div>
	);
};

export default VEBBeneficiary;
